import { IconButton, styled, TableCell, TableRow } from '@mui/material';
import { OrtPeriod } from '@types';
import { IconTrash } from 'assets/img';
import { DayHeaderCell } from './ort-table-day-header-cell';

type PeriodRowProps = {
  period: OrtPeriod;
  index: number;
  totalPeriods: number;
  dayLabel: string;
  isEditingThisDay: boolean;
  onDelete: (index: number) => void;
};

export const PeriodRow = ({
  period,
  index,
  totalPeriods,
  dayLabel,
  isEditingThisDay,
  onDelete,
}: PeriodRowProps) => {
  const rowSpan = totalPeriods + (isEditingThisDay ? 2 : 1);

  return (
    <TableRow data-testid={'ort-period-row'}>
      {index === 0 && <DayHeaderCell label={dayLabel} rowSpan={rowSpan} />}
      <StyledTableCell>{period.startTime}</StyledTableCell>
      <StyledTableCell>{period.endTime}</StyledTableCell>
      <StyledTableCell>
        {period.surchargeType === 'factor' ? `${period.surcharge}%` : `€${period.surcharge}`}
      </StyledTableCell>
      <StyledTableCell sx={{ textAlign: 'right' }}>
        <IconButton
          size="small"
          color="error"
          onClick={() => onDelete(index)}
          data-testid="delete-period-button"
        >
          <IconTrash fontSize="small" />
        </IconButton>
      </StyledTableCell>
    </TableRow>
  );
};
const StyledTableCell = styled(TableCell)({
  fontWeight: 'bold',
  width: '20%',
});
